export default __webpack_public_path__ + "static/media/hack-a-snack.c873b92c.gif";